import React from 'react'
import TextInput from '../../TextInput/TextInput'
import { FieldArray, useField } from 'formik'
import { getFieldValidationErrorMessageDOM, AddInstanceButton, ContextualDropdown, isFieldMultiple, contextualDropdownActionArray, ReadOnlyField } from '../helper'
import { modeTypes } from '../constants'

const MultipleInstance = ({ field, fieldWidth, mode }) => {
  const { formFieldUid } = field;

  const [numberFields, numberMeta] = useField(formFieldUid);

  return <FieldArray name={formFieldUid}>
    {({ insert, remove, move, push }) => {
      const isReadOnly = mode === modeTypes.readOnly || field.readOnly
      return <div data-test-id={`cs-asset-details-field-${formFieldUid}-multiple-instance-wrapper`}>
        {numberFields?.value?.map?.((item, index) => (
          <div className='asset-details-v2-fields-container__number-container__item' key={index} data-test-id={`cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-wrapper`}>
            <div className={`asset-details-v2-fields-container__number-container__item__input-container ${(field?.maxLength && field?.showCharacterCount) ? 'adjust-margin-top' : ''} ${(field?.errorMessage?.[index]) ? 'adjust-margin-left' : ''} `}>
              <div className='growContainer'>
                {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={item} copyLabel={field.title} copyIconSize={'small'} testId={`${formFieldUid}.${index}`} copyContent={isReadOnly ? item : ''} />
                  : <TextInput
                    type="number"
                    placeholder={field.placeholder || ''}
                    // className={field.className || ''}
                    testId={`cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-input`}
                    version={'v2'}
                    width={fieldWidth}
                    maxLength={field?.maxLength}
                    showCharacterCount={field?.showCharacterCount}
                    {...numberFields}
                    value={item}
                    name={`${formFieldUid}.${index}`}
                    error={numberMeta.touched && numberMeta.error?.[index]}
                  />}
              </div>
              {!isReadOnly && <ContextualDropdown contextualDropdownActionArray={contextualDropdownActionArray(field, index, remove)} field={field} />}
            </div>
            {Array.isArray(numberMeta.error)
              ? getFieldValidationErrorMessageDOM(numberMeta, index, undefined, `cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-validation-message`)
              : null}
          </div>
        ))}
        {typeof numberMeta.error === 'string' && getFieldValidationErrorMessageDOM(numberMeta, undefined, undefined, `cs-asset-details-field-${formFieldUid}-multiple-instance-validation-message`)}
        <div>
          {!isReadOnly && field.multiple && <AddInstanceButton field={field} valueLength={numberFields?.value?.length} push={push} />}
        </div>
      </div>
    }}
  </FieldArray>
}

const Number = (props: any) => {
  const { field, fieldWidth, mode } = props

  const { formFieldUid } = field;

  const [numberField, numberMeta] = useField(formFieldUid);
  const isMultiple = isFieldMultiple(field);
  const isReadOnly = mode === modeTypes.readOnly || field.readOnly

  return (
    <div className='asset-details-v2-fields-container__number-container' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-wrapper`}>
      {isMultiple
        ? <MultipleInstance field={field} fieldWidth={fieldWidth} mode={mode} />
        : <div className='asset-details-v2-fields-container__number-container__item'>
          <div>
            {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={numberField.value} copyLabel={field.title} copyIconSize={'small'} testId={field.formFieldUid} copyContent={isReadOnly ? numberField.value : ''} />
              : <TextInput
                type="number"
                placeholder={field.placeholder || ''}
                // className={field.className || ''}
                testId={`cs-asset-details-field-${field?.formFieldUid}-input`}
                version={'v2'}
                width={fieldWidth}
                maxLength={field?.maxLength}
                {...numberField}
                showCharacterCount={field?.showCharacterCount}
                error={numberMeta.touched && numberMeta.error}
              />}
          </div>
          {getFieldValidationErrorMessageDOM(numberMeta, undefined, undefined, `cs-asset-details-field-${field?.formFieldUid}-validation-message`)}
        </div>}
    </div>
  )
}

export default Number